import React from 'react';
import UserManagement from '../../components/common/UserManagement';
import { useAuthContext } from '../../context/AuthContext';

const UserManagementWrapper: React.FC = () => {
  // Read the live role from AuthContext (polled from the backend) instead of
  // a one-off localStorage read, so this stays correct if the role changes
  // mid-session.
  const { role } = useAuthContext();

  let userRole: 'SUPER_ADMIN' | 'ADMIN' | 'COMPANY_OWNER' | 'USER' = 'USER'; // default role

  if (role === 'super_admin') {
    userRole = 'SUPER_ADMIN';
  } else if (role === 'admin') {
    userRole = 'ADMIN';
  } else if (role === 'company_owner') {
    userRole = 'COMPANY_OWNER';
  } else {
    userRole = 'USER';
  }

  return <UserManagement userRole={userRole} />;
};

export default UserManagementWrapper;